// extracted by mini-css-extract-plugin
export var container = "TagsFilter-module--container--a8ed3";